export default __webpack_public_path__ + "static/media/caret-down-solid.8b3fa061.svg";